import React from 'react';
import MapLegend from './MapLegend';

const BottomBackButton = ({ isFullScreen, setIsFullScreen }) => {
  if (!isFullScreen) {
    return null;
  }
  
  return (
    <div className="bottom-nav">
      <MapLegend />
      <button 
        onClick={() => setIsFullScreen(false)}
        className="back-button"
      >
        Back
      </button>
    </div>
  );
};

export default BottomBackButton; 